import { observer } from 'mobx-react-lite';
import { POPUP } from '../../../game/popupManager';
import { COLORS } from '../../../game/data/colors';
import { IMAGES } from '../../../game/data/images';
import { TutorialPopups } from './TutorialPopups';
import { DATA } from '../../../game/data';
import { GreenButton } from '../Reusable/GreenButton';
import { REFUSED } from 'dns';
import { REWARD } from '../../../game/rewardedManager';
import { RewardPopup } from './RewardPopup';
import { formatNumber } from '../../../game/helpers';

export const MinimPopup: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div
      style={{
        padding: 8,
        backgroundColor: COLORS.zinc_700,
        borderRadius: 4,
        width: 500,
        textAlign: 'center',
      }}
    >
      {children}
    </div>
  );
};

export const Popups: React.FC = observer(() => {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {POPUP.offlineIncomeCollect && (
        <MinimPopup>
          Collected{' '}
          <b>
            <span style={{ color: COLORS.green_500 }}>$</span>
            {formatNumber(POPUP.offlineIncomeCollect.money)}
          </b>
          {POPUP.offlineIncomeCollect.isX2 && <b style={{ color: COLORS.yellow_500 }}> (x2)</b>} offline income
        </MinimPopup>
      )}
      {POPUP.rewardedVideoErrorPopup && (
        <MinimPopup>
          <div style={{ color: COLORS.red_500 }}>Failed to load video ad</div>
        </MinimPopup>
      )}
      {POPUP.populationIncreaseEvent && (
        <MinimPopup>
          <div
            dangerouslySetInnerHTML={{
              __html: POPUP.populationIncreaseEvent.message,
            }}
          ></div>
          <div className="tooltip-text">Passengers will arrive faster at this airport</div>
        </MinimPopup>
      )}
      {POPUP.airportFull && (
        <MinimPopup>
          <b style={{ color: COLORS.red_500 }}>{POPUP.airportFull.airport.name}</b> is full, other airlines will take the passengers!
        </MinimPopup>
      )}
      {POPUP.advanceCongrats && (
        <MinimPopup>
          <b style={{ color: COLORS.yellow_500 }}>CONGRATS!</b> Tickets are now{' '}
          <b style={{ color: COLORS.green_500 }}>x{DATA.currentAdvanceData.multiplier}</b> more expensive!
        </MinimPopup>
      )}
      <RewardPopup />
      <TutorialPopups />
    </div>
  );
});
